import type { ButtonHTMLAttributes } from "react"

import { tv } from "@/lib/utils/tv"

const pressableRow = tv({
  base: "focus-visible:ring-brand flex w-full items-center text-left transition-colors focus-visible:ring-2 focus-visible:outline-none focus-visible:ring-inset enabled:cursor-pointer",
})

export const PressableRow = ({ type = "button", className, ...rest }: ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button type={type} className={pressableRow({ className })} {...rest} />
)
